
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#2A333D","fill-rule":"evenodd"}},[_c('path',{attrs:{"stroke":"#2A333D","d":"M5.5 11.167v3H1.833v-3H5.5zm8.667-9.334v12.334l-.334-12H7.167l7-.334zM5.5 6.5v3H1.833v-3H5.5zm0-4.667v3H1.833v-3H5.5z"}}),_c('path',{attrs:{"d":"M6.667 5.333h6.667v1.333H6.667zm0 4h6.667v1.333H6.667zm0 4h6.667v1.333H6.667z"}})])])
          )
        }
      }
    